export interface ArticleMeta {
  slug: string;
  title: string;
  description: string;
  publishedAt: string; // ISO date
  updatedAt?: string;
  readTime?: number;   // minutes, auto-calculated if omitted
  ogImage?: string;    // path relative to public/, e.g. /og/slug.svg
}

// Реестр статей — добавляй сюда при создании нового файла
export const ARTICLES: ArticleMeta[] = [
  {
    slug: "skolko-stoit-reklama-u-blogera-instagram",
    title: "Сколько стоит реклама у блогеров в Instagram: цены в 2026 году",
    description: "Средние цены на рекламу у Instagram-блогеров по размеру аудитории и формату. Как не переплатить и проверить реальный охват через Trend.",
    publishedAt: "2026-05-01",
    updatedAt: "2026-06-09",
    readTime: 5,
  },
  {
    slug: "reklama-v-instagram-zakon-2026",
    title: "Реклама в Instagram в 2026: законы, маркировка и штрафы",
    description: "Как правильно маркировать рекламу у блогеров в Instagram в 2026 году. Требования ФАС, ЕРИР, штрафы за нарушения и практические советы.",
    publishedAt: "2026-05-10",
    updatedAt: "2026-06-09",
    readTime: 7,
  },
  {
    slug: "kak-kupit-reklamu-u-blogera-instagram",
    title: "Как купить рекламу у блогеров в Instagram: пошаговое руководство",
    description: "Пошаговое руководство по покупке рекламы у Instagram-блогеров: поиск, проверка статистики, согласование ТЗ, маркировка и оценка результата.",
    publishedAt: "2026-06-09",
    readTime: 8,
  },
  {
    slug: "mediakitblokera-chto-eto-i-kak-sdelat",
    title: "Медиакит блогера: что это и как его создать в 2026 году",
    description: "Что такое медиакит блогера, что в нём должно быть и как создать верифицированный медиакит с данными из Instagram API за 2 минуты.",
    publishedAt: "2026-06-09",
    readTime: 5,
  },
  {
    slug: "kak-proverit-blogera-na-nakrutku-instagram",
    title: "Как проверить блогера на ботов и накрутку в Instagram",
    description: "Как рекламодателю выявить накрутку у блогера: ERR, качество комментариев, динамика роста, анализ Reels. Чек-лист проверки перед оплатой.",
    publishedAt: "2026-06-09",
    readTime: 6,
  },
  {
    slug: "kak-monetizirovat-instagram-2026",
    title: "Как монетизировать Instagram в 2026 году: способы заработка для блогера",
    description: "Все рабочие способы заработка в Instagram: реклама у брендов, партнёрки, собственные продукты, Reels Play. С чего начать монетизацию блога.",
    publishedAt: "2026-06-09",
    readTime: 7,
  },
  {
    slug: "influenser-marketing-chto-eto-i-kak-rabotaet",
    title: "Инфлюенсер-маркетинг: что это и как работает реклама у блогеров",
    description: "Что такое инфлюенсер-маркетинг, форматы рекламы у блогеров, как выбрать инфлюенсера и считать результат. Практическое руководство для рекламодателей.",
    publishedAt: "2026-06-05",
    readTime: 7,
  },
  {
    slug: "okhvaty-v-instagram",
    title: "Охваты в Instagram: что это, норма и почему они падают",
    description: "Что такое охват в Instagram, чем отличается от показов, какие значения нормальны и что делать, когда цифры падают. С таблицей норм по размеру аккаунта.",
    publishedAt: "2026-01-14",
    readTime: 6,
  },
  {
    slug: "prodvizhenie-v-instagram-2026",
    title: "Продвижение в Instagram в 2026: рабочие методы для блогеров и брендов",
    description: "Какие методы продвижения в Instagram работают в 2026 году: органика, Reels, коллаборации, реклама у блогеров. Что уже не работает и почему.",
    publishedAt: "2026-01-22",
    readTime: 6,
  },
  {
    slug: "statistika-instagram-akkaunta",
    title: "Статистика аккаунта Instagram: какие показатели смотреть и как их читать",
    description: "Как открыть и читать статистику Instagram: охват, взаимодействия, демография. Что проверять у блогера перед покупкой рекламы.",
    publishedAt: "2026-02-05",
    readTime: 5,
  },
  {
    slug: "analitika-instagram-servisy",
    title: "Аналитика Instagram: сервисы и инструменты для блогеров и рекламодателей",
    description: "Обзор сервисов аналитики Instagram: встроенная статистика, Trend, LiveDune, Popsters, HypeAuditor. Какой инструмент выбрать под задачу.",
    publishedAt: "2026-03-20",
    readTime: 5,
  },
  {
    slug: "birzha-blogerov",
    title: "Биржа блогеров: что это, как работает и стоит ли пользоваться",
    description: "Как устроены биржи блогеров, какие популярны в России, плюсы и минусы. Когда биржа оправдана, а когда лучше работать с блогерами напрямую.",
    publishedAt: "2026-03-27",
    readTime: 5,
  },
  {
    slug: "vovlechennost-v-instagram-err",
    title: "Вовлечённость в Instagram: что такое ERR и как его считать",
    description: "Что такое ERR, чем отличается от ER, как рассчитать и какие значения нормальны. Как использовать вовлечённость при выборе блогера для рекламы.",
    publishedAt: "2026-02-13",
    readTime: 5,
  },
  {
    slug: "kontent-plan-dlya-instagram",
    title: "Контент-план для Instagram: как составить на месяц",
    description: "Как составить контент-план для Instagram на месяц: форматы, частота, баланс полезного и продающего контента. Шаблон и типичные ошибки.",
    publishedAt: "2026-02-20",
    readTime: 5,
  },
  {
    slug: "markirovka-reklamy-blogerom",
    title: "Как блогеру маркировать рекламу в Instagram: инструкция 2026",
    description: "Пошаговая инструкция по маркировке рекламы для блогеров: регистрация в ОРД, получение токена erid, правильное оформление публикации и подача отчёта.",
    publishedAt: "2026-05-29",
    readTime: 5,
  },
  {
    slug: "kak-uvelichit-podpischikov-instagram",
    title: "Как увеличить подписчиков в Instagram без накрутки",
    description: "Рабочие методы роста аудитории в Instagram в 2026: Reels, коллаборации, экспертный контент. Почему накрутка вредит монетизации блога.",
    publishedAt: "2026-03-06",
    readTime: 5,
  },
  {
    slug: "nativnaya-reklama-u-blogerov",
    title: "Нативная реклама у блогеров: как сделать интеграцию, которую смотрят",
    description: "Что такое нативная реклама у блогеров, форматы интеграций, почему жёсткое ТЗ убивает эффект и как измерить результат нативной рекламы.",
    publishedAt: "2026-04-03",
    readTime: 5,
  },
  {
    slug: "reklama-v-stories-instagram",
    title: "Реклама в Сторис Instagram: форматы, цены и как заказать",
    description: "Форматы рекламы в Сторис Instagram, ориентиры по стоимости, как заказать интеграцию и отследить результат. Частые ошибки рекламодателей.",
    publishedAt: "2026-04-10",
    readTime: 5,
  },
  {
    slug: "instagram-dlya-biznesa-2026",
    title: "Instagram для бизнеса в 2026: как продвигать бренд",
    description: "Как бизнесу использовать Instagram для продвижения: оформление профиля, стратегия контента, реклама у блогеров vs таргет. Типичные ошибки.",
    publishedAt: "2026-03-13",
    readTime: 6,
  },
  {
    slug: "kak-nayti-blogera-dlya-reklamy",
    title: "Как найти блогера для рекламы в Instagram: 5 рабочих способов",
    description: "Пять способов найти блогера для рекламы в Instagram: поиск по хэштегам, биржи, Trend, мониторинг конкурентов. Что спросить при первом контакте.",
    publishedAt: "2026-04-17",
    readTime: 5,
  },
  {
    slug: "kak-nabrat-prosmotry-reels",
    title: "Как набрать просмотры на Reels в Instagram",
    description: "Как алгоритм Instagram распределяет Reels, что делает ролик виральным, технические требования и лучшее время для публикации. С примерами структуры.",
    publishedAt: "2026-02-27",
    readTime: 5,
  },
  {
    slug: "ambassador-brenda",
    title: "Амбассадор бренда: кто это и как организовать долгосрочное сотрудничество",
    description: "Кто такой амбассадор бренда, чем отличается от рекламного блогера, как выбрать и оформить сотрудничество. Стоимость амбассадорских пакетов.",
    publishedAt: "2026-04-24",
    readTime: 5,
  },
  {
    slug: "ugc-kontent",
    title: "UGC-контент: что это и как использовать в рекламе у блогеров",
    description: "Что такое UGC-контент, виды пользовательского контента, как запустить сбор UGC и чем UGC-creator отличается от блогера. Юридическая сторона использования.",
    publishedAt: "2026-04-30",
    readTime: 5,
  },
  {
    slug: "kak-sostavit-tz-dlya-blogera",
    title: "Как составить ТЗ для блогера: шаблон и частые ошибки",
    description: "Структура технического задания для блогера, готовый шаблон ТЗ и типичные ошибки рекламодателей. Как найти баланс между контролем и свободой блогера.",
    publishedAt: "2026-05-07",
    readTime: 5,
  },
  {
    slug: "kak-schitat-cpm-cpa-bloger",
    title: "CPM и CPA в рекламе у блогеров: как считать и сравнивать",
    description: "Как рассчитать CPM, CPE, CPC и CPA для рекламы у блогеров в Instagram. Нормальные значения метрик и как использовать их при выборе блогера.",
    publishedAt: "2026-05-15",
    readTime: 5,
  },
  {
    slug: "oshibki-pri-rabote-s-blogerami",
    title: "Типичные ошибки при работе с блогерами: почему реклама не окупается",
    description: "10 ошибок рекламодателей при работе с Instagram-блогерами: выбор по подписчикам, накрутка, жёсткий скрипт, отсутствие отслеживания. Чеклист перед оплатой.",
    publishedAt: "2026-05-22",
    readTime: 6,
  },
];

export function getArticle(slug: string): ArticleMeta | undefined {
  return ARTICLES.find(a => a.slug === slug);
}

// Динамические импорты контента
export const ARTICLE_LOADERS: Record<string, () => Promise<{ default: string }>> = {
  "skolko-stoit-reklama-u-blogera-instagram":
    () => import("./skolko-stoit-reklama-u-blogera-instagram.md"),
  "reklama-v-instagram-zakon-2026":
    () => import("./reklama-v-instagram-zakon-2026.md"),
  "kak-kupit-reklamu-u-blogera-instagram":
    () => import("./kak-kupit-reklamu-u-blogera-instagram.md"),
  "mediakitblokera-chto-eto-i-kak-sdelat":
    () => import("./mediakitblokera-chto-eto-i-kak-sdelat.md"),
  "kak-proverit-blogera-na-nakrutku-instagram":
    () => import("./kak-proverit-blogera-na-nakrutku-instagram.md"),
  "kak-monetizirovat-instagram-2026":
    () => import("./kak-monetizirovat-instagram-2026.md"),
  "influenser-marketing-chto-eto-i-kak-rabotaet":
    () => import("./influenser-marketing-chto-eto-i-kak-rabotaet.md"),
  "okhvaty-v-instagram":
    () => import("./okhvaty-v-instagram.md"),
  "prodvizhenie-v-instagram-2026":
    () => import("./prodvizhenie-v-instagram-2026.md"),
  "statistika-instagram-akkaunta":
    () => import("./statistika-instagram-akkaunta.md"),
  "analitika-instagram-servisy":
    () => import("./analitika-instagram-servisy.md"),
  "birzha-blogerov":
    () => import("./birzha-blogerov.md"),
  "vovlechennost-v-instagram-err":
    () => import("./vovlechennost-v-instagram-err.md"),
  "kontent-plan-dlya-instagram":
    () => import("./kontent-plan-dlya-instagram.md"),
  "markirovka-reklamy-blogerom":
    () => import("./markirovka-reklamy-blogerom.md"),
  "kak-uvelichit-podpischikov-instagram":
    () => import("./kak-uvelichit-podpischikov-instagram.md"),
  "nativnaya-reklama-u-blogerov":
    () => import("./nativnaya-reklama-u-blogerov.md"),
  "reklama-v-stories-instagram":
    () => import("./reklama-v-stories-instagram.md"),
  "instagram-dlya-biznesa-2026":
    () => import("./instagram-dlya-biznesa-2026.md"),
  "kak-nayti-blogera-dlya-reklamy":
    () => import("./kak-nayti-blogera-dlya-reklamy.md"),
  "kak-nabrat-prosmotry-reels":
    () => import("./kak-nabrat-prosmotry-reels.md"),
  "ambassador-brenda":
    () => import("./ambassador-brenda.md"),
  "ugc-kontent":
    () => import("./ugc-kontent.md"),
  "kak-sostavit-tz-dlya-blogera":
    () => import("./kak-sostavit-tz-dlya-blogera.md"),
  "kak-schitat-cpm-cpa-bloger":
    () => import("./kak-schitat-cpm-cpa-bloger.md"),
  "oshibki-pri-rabote-s-blogerami":
    () => import("./oshibki-pri-rabote-s-blogerami.md"),
};
